import { useActiveSpeakersState, useAttendeeStatus } from 'amazon-chime-sdk-component-library-react'
import useRemoteParticipants from './useRemoteParticipants'

/**
 * Détecte si le premier participant distant est en train de parler
 * @returns Boolean indiquant si le participant parle (vérifie activeSpeakers ET statut muted)
 */
export default function useRemoteParticipantSpeaking(): boolean {
  const { firstRemoteAttendee } = useRemoteParticipants()
  const activeSpeakers = useActiveSpeakersState()

  const attendeeId = firstRemoteAttendee?.chimeAttendeeId || ''
  const attendeeStatus = useAttendeeStatus(attendeeId)

  if (!attendeeId) {
    return false
  }

  return activeSpeakers.includes(attendeeId) && !attendeeStatus.muted
}
